import { render, staticRenderFns } from "./PayTable.vue?vue&type=template&id=0f68fbc9&scoped=true&"
import script from "./PayTable.vue?vue&type=script&lang=js&"
export * from "./PayTable.vue?vue&type=script&lang=js&"
import style0 from "./PayTable.vue?vue&type=style&index=0&id=0f68fbc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68fbc9",
  null
  
)

export default component.exports